import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

type Messages = {
	base: MessageDescriptor;
	baseAppField: MessageDescriptor;
	edit: MessageDescriptor;
	require: MessageDescriptor;
	remove: MessageDescriptor;
	sort: MessageDescriptor;
};

export const messages: Messages = defineMessages({
	base: {
		id: 'project-settings-apps.issue-type-page.field.field-tooltip.base',
		defaultMessage: "{fieldCreator} created this field. You can't:",
		description: `Introduction to a list of operations which are blocked in a particular field.
        e.g. "Jira created this field. You can't:
            * edit its name
            * remove it
        `,
	},
	baseAppField: {
		id: 'project-settings-apps.issue-type-page.field.field-tooltip.base-app-field',
		defaultMessage: "The {fieldCreator} app created this field. You can't:",
		description: `Introduction to a list of operations which are blocked in a particular field.
        e.g. "Jira created this field. You can't:
            * edit its name
            * remove it
        `,
	},
	edit: {
		id: 'project-settings-apps.issue-type-page.field.field-tooltip.edit',
		defaultMessage: 'edit its name',
		description: 'Describes the act of renaming a field or changing its description',
	},
	require: {
		id: 'project-settings-apps.issue-type-page.field.field-tooltip.require',
		defaultMessage: "change if it's required",
		description: 'Describes the act of making a field (un)required for an issue type',
	},
	remove: {
		id: 'project-settings-apps.issue-type-page.field.field-tooltip.remove',
		defaultMessage: 'remove it',
		description: 'Describes the act of removing a field from an issue type',
	},
	sort: {
		id: 'project-settings-apps.issue-type-page.field.field-tooltip.sort',
		defaultMessage: 'reorder it',
		description: 'Describes the act of moving a field to a different position within an issue type',
	},
});
